<template>
  <div class="c-action-result">
    <div class="c-title">
      <div class="c-text-ad">
        <a href="javascript:;" class="g-pull-right" @click="$emit('on-clear')">清空</a>
        <span>还可添加{{ title }}: &nbsp;{{ length }} 个</span>
      </div>
      <div v-show="subTitle" class="c-extend-ad">
        <span>类目词：{{ cateLen }}</span>
        <span>关键词：{{ wordLen }}</span>
      </div>
    </div>
    <div class="c-content">
      <Spin size="large" fix v-if="!loading" />
      <div class="c-form">
        <div class="c-head">
          <Dropdown placement="bottom-start" @on-click="handleDrop">
            <a href="javascript:void(0)">{{ filterValue }} <Icon type="ios-arrow-down"></Icon></a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="drop in filters" :key="drop.key" :name="drop.key" :selected="filterCurrent(drop.key)">
                {{ drop.value }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <div class="c-head-cover">
            <span>覆盖人数</span>
          </div>
        </div>
        <div class="c-body">
          <div class="list-wrap">
            <div class="list-item" v-for="word in filterData" :key="word.id">
              <span class="name">{{ word.name }}</span>
              <span class="num">{{ word.num }}</span>
              <span class="operate">
                <el-button type="text" @click="$emit('on-delete', word)">删除</el-button>
                <el-button type="text" @click="queryHandle(word)">查关键词</el-button>
              </span>
            </div>
          </div>
          <div v-show="!len" class="no-data">
            <Icon type="ios-filing-outline" size="58" color="#efefef" />
            <span>暂未选择</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const filters = [
  {
    key: 'all',
    value: '全部'
  },
  {
    key: 'category',
    value: '类目词'
  },
  {
    key: 'keyword',
    value: '关键词'
  }
]
export default {
  name: 'actionResult',
  props: {
    value: {
      type: Array
    },
    title: {
      type: String,
      default: '已选'
    },
    subTitle: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean
    },
    max: {
      type: Number,
      default: 20
    }
  },
  computed: {
    len() {
      return this.value.length
    },
    cateLen() {
      return this.value.filter((ret) => ret.type.toLowerCase() === 'category').length
    },
    wordLen() {
      return this.value.filter((ret) => ret.type.toLowerCase() === 'keyword').length
    },
    length() {
      return this.max - this.len
    },
    filterCurrent() {
      return (val) => val === this.current
    },
    filterValue() {
      const { value } = this.filters.filter((ret) => ret.key === this.current).pop()
      return value || ''
    },
    filterData() {
      return this.value.filter((ret) => this.current === 'all' || ret.type.toLowerCase() === this.current).sort((a, b) => a._time - b._time)
    }
  },
  data() {
    return {
      filters, // 下拉列表
      current: 'all' // 当前过滤结果
    }
  },
  methods: {
    handleDrop(val) {
      this.current = val
    },
    queryHandle(item) {
      this.$emit('on-search', {
        id: item.id,
        name: item.name,
        tag_type: item.type
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-action-result {
  min-width: 280px;
  border: solid 1px #dee4f5;

  .c-title {
    height: 50px;
    background-color: #fafbfe;
    padding: 6px 8px;
    color: #999;
    border-bottom: 1px solid #dcdee2;

    .c-text-ad {
      font-size: 14px;
      color: #333;
      line-height: 20px;
      font-weight: 500;
    }

    .c-extend-ad span {
      &:first-child {
        margin-right: 16px;
      }
    }
  }

  .c-content {
    position: relative;

    .c-form {
      .c-head {
        font-size: 14px;
        display: flex;
        padding: 8px 12px;
        font-weight: 500;
        border-bottom: 1px solid #dcdee2;

        .ivu-dropdown,
        .ivu-dropdown-menu {
          width: 66px;
          min-width: 66px;
        }

        .c-head-cover {
          margin-left: 36px;
        }
      }

      .c-body {
        overflow: auto;
        height: 368px;
        padding: 8px 12px 0;

        .list-item {
          display: flex;
          align-items: center;
          span {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: inline-block;
            line-height: 26px;
          }

          .name {
            flex-basis: 35%;
          }

          .num {
            flex-basis: 20%;
          }

          .operate {
            .el-button {
              visibility: hidden;
            }
          }

          &:last-child {
            margin-bottom: 0;
          }

          &:hover {
            .el-button {
              visibility: visible;
            }
          }
        }

        .no-data {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          span {
            color: #c1c1c1;
          }
        }
      }
    }
  }
}
</style>
